var _defs, _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherReceivable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M26.042 15.205h-7.835"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M18.134 10.288a4.582 4.582 0 118.441-2.566 4.56 4.56 0 01-.76 2.624"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 29.721,
    cy: 18.655,
    r: 1.501
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M31.13 9.396l2.61-1.07-.1 5.9c1.27 1.9 1.3 4.15 1.3 4.15l3.52 1.23v5.56l-3.72 1.36s-.59 1.65-1.72 2.65c-1.16 1.03-2.45 1.59-2.45 1.59l-.79 3.5h-3.49l-.66-3.11H16.721l-.66 2.99h-3.49l-.64-3.41s-2.932-2.036-3.969-3.76c-1.984-3.298-1.196-6.66-.715-8.456.222-.829-.118-1.703-.78-2.248l-2.299-1.894.803-1.614 3.796 1.281a2.278 2.278 0 002.371-.646s2.003-1.475 2.801-1.936"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherReceivable);
export default __webpack_public_path__ + "static/media/otherReceivable.97ca921cbcb6e9fb68f44d2b47e48b34.svg";
export { ForwardRef as ReactComponent };